import React from "react";
import { Link } from "react-router-dom";

import Icon from "layout/atoms/Icon";

import { ReactComponent as LogoSvg } from "assets/logo.svg";
import { Wrapper } from "./styles";

const Logo = ({ size, circle }) => {
  return (
    <Wrapper size={size} circle={circle}>
      <Link to="/">
        <Icon src={LogoSvg} size={circle ? "40px" : "35px"} />
      </Link>
    </Wrapper>
  );
};

export default Logo;
